import React from 'react';
import MonthlyReferralsOverTimeChart from './MonthlyReferralsOverTimeChart';

export default function SentReferralsOverTime({ startDate, endDate }) {
  return (
    <MonthlyReferralsOverTimeChart
      title="Sent Referrals Over Time"
      subtitle="Monthly sent referrals for the last 12 months"
      tooltipLabel="Sent referrals"
      noteLabel="Current month bars are highlighted in green."
      endpointDirection="sent"
      responseKey="monthly_sent_referrals"
      startDate={startDate}
      endDate={endDate}
    />
  );
}
